import { render, staticRenderFns } from "./CheckoutFormTextarea.vue?vue&type=template&id=152b4b75&scoped=true"
import script from "./CheckoutFormTextarea.vue?vue&type=script&lang=js"
export * from "./CheckoutFormTextarea.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFormTextarea.vue?vue&type=style&index=0&id=152b4b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b4b75",
  null
  
)

export default component.exports